export default __webpack_public_path__ + "static/media/Triangles_03.09e68dea.png";